/**
 * @constant {string} - Username reserved for Lavu Admin, user from manage
 */
export const LAVU_ADMIN_USERNAME = 'poslavu_admin';
